import { CircularProgress, Grid, Paper, Typography } from "@material-ui/core";
import { ChevronRight } from "@material-ui/icons";
import { MouseEventHandler, useMemo } from "react";

import {
  getDataStreak,
  getFormattedDate,
  getStreakDates,
  weekDays,
} from "../../../learning/utils";
import { getDayNameOfTheWeek } from "../../formattedDate";
import { useParticipantActivity } from "../../hooks";
import { Button } from "../button";
import { StreakDay } from "./streak-day.component";
import { useStyles } from "./streak.styles";

type StreakProps = {
  streakDates: Date[];
  onClick: MouseEventHandler<HTMLButtonElement>;
};

export const Streak = ({ streakDates, onClick }: StreakProps) => {
  const classes = useStyles();
  const currentDay = useMemo(() => {
    return getDayNameOfTheWeek();
  }, []);

  const { data: monthlyActivityData, isFetching } = useParticipantActivity();

  const datesToUse = monthlyActivityData || streakDates;

  const streakDays = getStreakDates(
    getFormattedDate(datesToUse),
    getFormattedDate(weekDays)
  );

  const streakData = getDataStreak(streakDays, getFormattedDate(weekDays));
  const hasStreak = streakData.some(({ isStreak }) => isStreak);

  return (
    <Paper
      id="learning-wt-5"
      className={classes.paper}
      variant="outlined"
      data-testid="streak"
    >
      <Grid container alignContent="center" justifyContent="center">
        <Grid container item alignContent="center" justifyContent="center">
          <Typography className={classes.title} data-testid="title">
            {hasStreak ? "Continue your streak" : "Start your streak"}
          </Typography>
        </Grid>
        <Grid container item alignContent="center" justifyContent="center">
          <Typography className={classes.subtitle} data-testid="subtitle">
            Practice consecutive days to earn a streak.
          </Typography>
        </Grid>
        <Grid
          container
          className={classes.container}
          item
          direction="row"
          alignContent="center"
          alignItems="center"
          justifyContent="space-between"
          wrap="nowrap"
          xs={12}
          sm={12}
          md={12}
          spacing={2}
        >
          {isFetching ? (
            <Grid className={classes.loading}>
              <CircularProgress />
            </Grid>
          ) : (
            streakData.map(({ dayName, isStreak }) => (
              <StreakDay
                key={dayName}
                day={dayName}
                isStreak={isStreak}
                isSelected={dayName === currentDay}
              />
            ))
          )}
        </Grid>
        <Button
          variant="outlined"
          className={classes.button}
          endIcon={<ChevronRight />}
          data-testid="button"
          onClick={onClick}
        >
          {hasStreak ? "Continue your streak" : "Start your streak"}
        </Button>
      </Grid>
    </Paper>
  );
};
